import apiClient from './apiClient';

// Avisos del seguimiento de ANSES (V260): qué tipos (Favorable, Desfavorable, Citado, Desaparecido)
// recibe cada usuario y por dónde (campana / mail). Todo arranca apagado.
// preferencias = [{ tipo, etiqueta, inApp, email }]

export const obtenerMisAvisos = () =>
    apiClient.get('/tramites/para-aprobar/mis-avisos').then((r) => r.data);

export const guardarMisAvisos = (preferencias) =>
    apiClient.put('/tramites/para-aprobar/mis-avisos', preferencias).then((r) => r.data);

// Solo ADMIN / PROGRAMADOR: [{ idUsuario, nombre, rol, preferencias }]
export const obtenerAvisosDeTodos = () =>
    apiClient.get('/admin/anses/avisos').then((r) => r.data);

export const guardarAvisosDeUsuario = (idUsuario, preferencias) =>
    apiClient.put(`/admin/anses/avisos/${idUsuario}`, preferencias).then((r) => r.data);
